import api from "../axios";
import Api from "../Api";

export async function getList(search, start, limit) {
  const response = await api

  
  
    .get(
      `${Api.request.URL}/exhibition?search=${
        search === undefined ? "" : search
      }&start=${start === undefined ? 0 : start}&limit=${
        limit === undefined ? 10 : limit
      }`
    )
    .then((res) => {
      return res.data.data;
    })
    .catch((error) => {
      return error.response.data.sucess;
    });
  return response;
}


export async function uploadBanner(DataForm) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${Api.request.URL}/exhibition/upload/banner`,
      data: DataForm,
    };
  
    const response = await api
      .request(config)
      .then((res) => {
       return res.data.msg;
      })
      .catch((error) => {
        console.log(error);
      });
  
    return response;
  }


  export async function uploadCover(DataForm) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${Api.request.URL}/exhibition/upload/cover`,
      data: DataForm,
    };
  
    const response = await api
      .request(config)
      .then((res) => {
       return res.data.msg;
      })
      .catch((error) => {
        console.log(error);
      });
  
    return response;
  }



  export async function uploadArtist(DataForm) {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${Api.request.URL}/exhibition/upload/banner`,
      data: DataForm,
    };
  
    const response = await api
      .request(config)
      .then((res) => {
       return res.data.msg;
      })
      .catch((error) => {
        console.log(error);
      });
  
    return response;
  }


export async function getFindById(id) {
    const response = await api
      .get(`${Api.request.URL}/exhibition/${id}`)
      .then((res) => {
        return res.data.data;
      })
      .catch((error) => {
        return error.response.data.msg;
      });
    return response;
  }


export async function createExihibit(ArrayData) {
    const response = await api
      .post(`${Api.request.URL}/exhibition`,ArrayData)
      .then((res) => {
        // console.log("data data: ", res.data);
        return res.data.msg;
      })
      .catch((error) => {
        return error.response.data.errors;
      });
    return response;
  }

  export async function updateExhibit(ArrayData) {
    const response = await api
      .put(`${Api.request.URL}/exhibition/${ArrayData.id}`,ArrayData)
      .then((res) => {
        // console.log("data data: ", res.data);
        return res.data.msg;
      })
      .catch((error) => {
        return error.response.data.errors;
      });
    return response;
  }
  